// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3996":"11cc7dfb","5993":"dcd5ad3f","8665":"dcd5ad3f"}[chunkId] + ".chunk.css";
};